export default __webpack_public_path__ + "static/media/two_wheeler.3eac367a.svg";